import React, { useState, useEffect, useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
    Typography,
    Paper,
    TableContainer,
    Tooltip,
    TablePagination,
    IconButton,
    Checkbox,
    Box,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Stack
} from '@mui/material';
import moment from 'moment';
import axiosInstance from '../../../lib/axios';
import CloseIcon from '@mui/icons-material/Close';
import UpdateIcon from '@mui/icons-material/Update';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BulkUpdateEnq = ({ open, onClose, propId, fetchEnquiry, selectedFollowBy, statusFilter, setOpenBulkUpdate }) => {
    console.log('statusFilter', statusFilter)
    const [enquiryRows, setEnquiryRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [selectAll, setSelectAll] = useState(false);
    const [searchTerms, setSearchTerms] = useState({});
    const [bulkUpdateData, setBulkUpdateData] = useState({
        Remark: '',
        Status: ''
    });
    const isMounted = React.useRef(true);
    const [showUpdatePanel, setShowUpdatePanel] = useState(false);
    const [updating, setUpdating] = useState(false);

    const enqTypeOptions = [
        'Hot', 'Warm', 'Cold', 'Booked', 'Refund', 'Not interested', 'Incorrect Lead', 'Low Budget', 'Others'
    ];
    console.log('statusFilter:', statusFilter);

    const statusOptions = [
        { value: '1', label: 'Open' },
        { value: '5', label: 'Close' },
        { value: '0', label: 'Cancel' }
    ];

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const visitStatusOptions = [
        { value: 'Y', label: 'Yes' },
        { value: 'N', label: 'No' }
    ];

    useEffect(() => {
        if (open && propId) {
            fetchEnquiryList();
        }
    }, [open, propId, selectedFollowBy]);

    const fetchEnquiryList = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post(
                `TrnEnq/GetTrnEnqDashBoard`,
                {
                    PageNumber: 1,
                    PageSize: 10000,
                    SearchText: '',
                    PropId: propId,
                    Flag: statusFilter,
                    "FlwUserId": selectedFollowBy?.FlwUserId || ""
                }
            );

            if (response.data.Status === 0 && response.data.Data) {
                const formattedData = response.data.Data.map(item => ({
                    ...item,
                    EnqDt: item.EnqDt ? moment(item.EnqDt).format('DD-MM-YYYY') : '',
                    NextFlwDt: item.NextFlwDt ? moment(item.NextFlwDt).format('DD-MM-YYYY') : '',
                    FlwDt: item.FlwDt ? moment(item.FlwDt).format('DD-MM-YYYY') : '',
                    LastFlwDt: item.LastFlwDt ? moment(item.LastFlwDt).format('DD-MM-YYYY') : '',
                    CheckInDt: item.CheckInDt ? moment(item.CheckInDt).format('DD-MM-YYYY') : '',
                    VisitDt: item.VisitDt ? moment(item.VisitDt).format('DD-MM-YYYY') : '',
                    OtherRmk: item.OtherRmk,
                    VisitSt: item.VisitSt === 'Y' ? 'Yes' : item.VisitSt === 'N' ? 'No' : '',
                    Status: item.Status === "0" ? 'Cancel' :
                        item.Status === "1" ? 'Open' :
                            item.Status === "5" ? 'Close' :
                                item.Status || 'Unknown'
                }));
                setEnquiryRows(formattedData);
                setSelectedRows(new Set());
                setSelectAll(false);
                setSearchTerms({})
                setPage(0);
                setShowUpdatePanel(false)
            } else {
                setEnquiryRows([]);
            }
        } catch (error) {
            console.error('Error fetching enquiries:', error);
            setEnquiryRows([]);
            toast.error('Failed to fetch enquiries');
        } finally {
            setLoading(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };

    const handleRowSelect = (enqId) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(enqId)) {
            newSelected.delete(enqId);
        } else {
            newSelected.add(enqId);
        }
        setSelectedRows(newSelected);

        if (newSelected.size > 0) {
            setShowUpdatePanel(true);
        } else {
            setShowUpdatePanel(false);
            setBulkUpdateData({ Remark: '', Status: '' });
        }
    }

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows(new Set());
            setShowUpdatePanel(false);
        } else {
            const currentPageRows = getCurrentPageRows();
            const newSelected = new Set(selectedRows);
            currentPageRows.forEach(row => {
                newSelected.add(row.EnqId);
            });
            setSelectedRows(newSelected);
            setShowUpdatePanel(true);
        }
        setSelectAll(!selectAll);
    };

    const getCurrentPageRows = () => {
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        const filteredRows = getFilteredRows();
        return filteredRows.slice(start, end);
    };

    const getFilteredRows = () => {
        let filtered = enquiryRows;

        filtered = filtered.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (value === null || value === undefined) return false;
                return value.toString().toLowerCase().includes(term.toLowerCase());
            });
        });

        return filtered;
    };

    const isAllSelectedOnPage = () => {
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return false;
        return currentPageRows.every(row => selectedRows.has(row.EnqId));
    };

    const handleBulkUpdateChange = (field, value) => {
        setBulkUpdateData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleBulkUpdateSubmit = async () => {
        if (selectedRows.size === 0) {
            toast.warning('Please select at least one enquiry to update');
            return;
        }

        if (!bulkUpdateData.Remark && !bulkUpdateData.Status) {
            toast.warning('Please fill at least Remark or Status to update');
            return;
        }

        setUpdating(true);
        try {
            const getStatusValue = (statusLabel) => {
                switch (statusLabel) {
                    case 'Open': return '1';
                    case 'Close': return '5';
                    case 'Cancel': return '0';
                    default: return '';
                }
            };
            const updatePayload = Array.from(selectedRows).map(enqId => ({
                EnqId: enqId,
                Flag: "BulkStatus",
                Status: getStatusValue(bulkUpdateData.Status),
                Remark: bulkUpdateData.Remark || ""
            }));

            const response = await axiosInstance.post(`TrnEnq/TrnEnqStatus_BulkUpdate`, updatePayload);

            if (response.data.Status === 0) {
                toast.success(`Successfully updated ${selectedRows.size} enquiry(s)`);

                setBulkUpdateData({ Remark: '', Status: '' });
                setSelectedRows(new Set());
                setSelectAll(false);
                setShowUpdatePanel(false);
                // setOpenBulkUpdate(false);
                if (fetchEnquiry) {
                    await fetchEnquiry();
                }
                onClose();

            } else {
                toast.error(response.data.Message || 'Failed to update enquiries');
            }
        } catch (error) {
            console.error('Bulk update error:', error);
            toast.error('Error occurred while updating enquiries');
        } finally {
            setUpdating(false);
        }
    };

    const columns = [
        { id: 'select', label: '', width: 40 },
        { id: 'FlwEmpNm', label: 'Follow By', width: 85 },
        { id: 'EnqNo', label: 'Enquiry No', width: 85 },
        { id: 'EnqDt', label: 'EnqDate', width: 90 },
        { id: 'LastFlwDt', label: 'LastFollowUp', width: 100 },
        { id: 'Status', label: 'Status', width: 50 },
        { id: 'EnqTypeNm', label: 'EnqType', width: 60 },
        { id: 'VisitSt', label: 'Visit', width: 50 },
        { id: 'Remark', label: 'Remark', width: 130 },
        { id: 'NextFlwDt', label: 'NextFollowUp', width: 100 },
        { id: 'EnqBy', label: 'EnqBy', width: 90 },
        { id: 'EnqFor', label: 'EnqFor', width: 90 },
        { id: 'MobileNo', label: 'Mobile', width: 100 },
        { id: 'OcupntMob', label: 'OcupntMob', width: 100 },
        { id: 'Tenure', label: 'Tenure', width: 60 },
        { id: 'SourceBy', label: 'Source By', width: 80 },
        { id: 'SourceName', label: 'Source', width: 85 },
        { id: 'VisitEmpNm', label: 'VisitWith', width: 100 },
        { id: 'VisitRemark', label: 'VisitRemark', width: 150 },
        { id: 'BrokerName', label: 'Broker', width: 100 },
        { id: 'EmailId', label: 'EmailId', width: 130 },
        { id: 'CheckInDt', label: 'CheckIn Date', width: 100 },
        { id: 'RoomTypeName', label: 'RoomType', width: 85 },
        { id: 'VisitDt', label: 'Visit Date', width: 90 },
        { id: 'SemesterName', label: 'Semester', width: 100 },
        { id: 'CourseName', label: 'Course', width: 100 },
        { id: 'DesiName', label: 'Designation', width: 100 }
    ];

    const getCellStyle = (columnId, value) => {
        if (columnId === 'Status') {
            switch (value) {
                case 'Cancel': return { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center', padding: '2px 4px' };
                case 'Close': return { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center', padding: '2px 4px' };
                case 'Open': return { backgroundColor: '#2196F3', color: 'white', borderRadius: '4px', textAlign: 'center', padding: '2px 4px' };
                default: return { textAlign: 'center' };
            }
        }
        if (columnId === 'EnqTypeNm') {
            switch (value) {
                case 'Hot': return { backgroundColor: '#FF0000', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Warm': return { backgroundColor: '#FFBF00', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Booked': return { backgroundColor: '#01bc5f', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Refund': return { backgroundColor: '#4d7499', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Not interested': return { backgroundColor: '#FF6347', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Incorrect Lead': return { backgroundColor: '#922b21', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Cold': return { backgroundColor: '#0000FF', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Low Budget': return { backgroundColor: '#148f77', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                case 'Others': return { backgroundColor: '#FFA500', color: 'white', borderRadius: '4px', padding: '2px 4px' };
                default: return {};
            }
        }
        if (columnId === 'VisitSt') {
            return value === 'Yes'
                ? { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center', padding: '2px 4px' }
                : value === 'No' ? { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center', padding: '2px 4px' }
                    : { textAlign: 'center' };
        }
        return {};
    };

    const filteredRows = getFilteredRows();
    const currentPageRows = getCurrentPageRows();
    const allSelectedOnPage = isAllSelectedOnPage();
    const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        maxHeight: '90vh',
                    }
                }}
            >
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable
                    pauseOnHover
                    limit={3}
                />
                <DialogTitle
                    sx={{
                        backgroundColor: '#635bff',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px 16px',
                        borderBottom: '1px solid #e0e0e0'
                    }}
                >
                    <Typography variant="h6" component="span" sx={{ fontSize: '1.1rem' }}>
                        Bulk Update Enquiries
                        {selectedRows.size > 0 && (
                            <Typography component="span" sx={{ ml: 2, fontSize: '0.75rem', fontWeight: 'normal' }}>
                                ({selectedRows.size} selected)
                            </Typography>
                        )}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.2)'
                            }
                        }}
                    >
                        <CloseIcon sx={{ fontSize: '1.2rem' }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>

                    {showUpdatePanel && selectedRows.size > 0 && (
                        <Box sx={{
                            padding: 1.5,
                            backgroundColor: '#f5f5f5',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            alignItems: 'flex-end'
                        }}>

                            <TextField
                                size="small"
                                label="Remark"
                                value={bulkUpdateData.Remark}
                                onChange={(e) => handleBulkUpdateChange('Remark', e.target.value)}
                                variant="filled"
                                sx={{ minWidth: 200, flex: 2 }}
                                inputProps={{ style: { fontSize: '0.75rem', padding: '8px' } }}
                                className="custom-textfield"
                            />
                            <FormControl className="custom-select" size="small" variant="filled" sx={{
                                minWidth: 120,
                                maxWidth: 150, flex: 1
                            }}>
                                <InputLabel sx={{ fontSize: '0.75rem' }}>Status</InputLabel>
                                <Select
                                    value={bulkUpdateData.Status}
                                    onChange={(e) => handleBulkUpdateChange('Status', e.target.value)}
                                    label="Status"
                                    sx={{ fontSize: '0.75rem' }}
                                    className="custom-textfield"
                                >
                                    <MenuItem value="" sx={{ fontSize: '0.75rem' }}>
                                        <em>Select Status</em>
                                    </MenuItem>
                                    {statusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.label} sx={{ fontSize: '0.75rem' }}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Stack direction="row" spacing={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleBulkUpdateSubmit}
                                    disabled={updating}
                                    startIcon={<UpdateIcon sx={{ fontSize: '0.9rem' }} />}
                                    size="small"
                                    sx={{ fontSize: '0.7rem', padding: '4px 10px' }}
                                >
                                    {updating ? 'Updating...' : `Update (${selectedRows.size})`}
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setShowUpdatePanel(false);
                                        setBulkUpdateData({
                                            EnqTypeNm: '',
                                            NextFlwDt: '',
                                            Remark: '',
                                            Status: '',
                                            VisitSt: ''
                                        });
                                    }}
                                    size="small"
                                    sx={{ fontSize: '0.7rem', padding: '4px 10px' }}
                                >
                                    Cancel
                                </Button>
                            </Stack>
                        </Box>
                    )}

                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <CircularProgress size={40} />
                        </div>
                    ) : enquiryRows.length > 0 ? (
                        <>
                            <TableContainer sx={{ maxHeight: showUpdatePanel ? 'calc(90vh - 260px)' : 'calc(90vh - 160px)' }}>
                                <Table stickyHeader size="small" sx={{ minWidth: 650 }}>
                                    <TableHead>
                                        <TableRow sx={{ height: '32px' }}>
                                            <TableCell
                                                sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#dddbff',
                                                    whiteSpace: 'nowrap',
                                                    borderRight: '1px solid #e0e0e0',
                                                    padding: '2px 6px',
                                                    width: 40,
                                                    fontSize: '0.7rem',
                                                    height: '32px'
                                                }}
                                            >
                                                <Checkbox
                                                    checked={allSelectedOnPage && filteredRows.length > 0}
                                                    indeterminate={!allSelectedOnPage && currentPageRows.some(row => selectedRows.has(row.EnqId))}
                                                    onChange={handleSelectAll}
                                                    size="small"
                                                    sx={{ padding: '2px' }}
                                                />
                                            </TableCell>
                                            {columns.filter(col => col.id !== 'select').map(column => (
                                                <TableCell
                                                    key={column.id}
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        backgroundColor: '#dddbff',
                                                        whiteSpace: 'nowrap',
                                                        borderRight: '1px solid #e0e0e0',
                                                        padding: '2px 6px',
                                                        width: column.width,
                                                        minWidth: column.width,
                                                        fontSize: '0.7rem',
                                                        height: '32px'
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                        <Typography sx={{ fontSize: '0.7rem', fontWeight: 'bold' }}>
                                                            {column.label}
                                                        </Typography>
                                                        <TextField
                                                            size="small"
                                                            variant="outlined"
                                                            placeholder="Search"
                                                            value={searchTerms[column.id] || ''}
                                                            onChange={(e) => handleSearchChange(column.id, e.target.value)}
                                                            sx={{
                                                                width: '100%',
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '8px',
                                                                    backgroundColor: '#f9f9f9',
                                                                    fontSize: '0.7rem',
                                                                    height: '25px',
                                                                    padding: '0 4px'
                                                                },
                                                                '& .MuiOutlinedInput-input': {
                                                                    padding: '4px 6px',
                                                                    fontSize: '0.7rem'
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderWidth: '1px'
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentPageRows.map((row) => (
                                            <TableRow
                                                hover
                                                key={row.EnqId}
                                                sx={{
                                                    backgroundColor: selectedRows.has(row.EnqId) ? '#e3f2fd' : 'inherit',
                                                    '&:hover': {
                                                        backgroundColor: selectedRows.has(row.EnqId) ? '#bbdef5' : '#f5f5f5'
                                                    },
                                                    cursor: 'pointer',
                                                    height: '28px'
                                                }}
                                            >
                                                <TableCell
                                                    sx={{
                                                        padding: '1px 4px',
                                                        borderRight: '1px solid #e0e0e0',
                                                        whiteSpace: 'nowrap',
                                                        height: '28px'
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <Checkbox
                                                        checked={selectedRows.has(row.EnqId)}
                                                        onChange={() => handleRowSelect(row.EnqId)}
                                                        size="small"
                                                        sx={{ padding: '2px' }}
                                                    />
                                                </TableCell>
                                                {columns.filter(col => col.id !== 'select').map(column => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            sx={{
                                                                padding: '1px 6px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                borderRight: '1px solid #e0e0e0',
                                                                maxWidth: column.width,
                                                                minWidth: column.width,
                                                                fontSize: '0.7rem',
                                                                height: '28px',
                                                                lineHeight: '1.2',
                                                                ...getCellStyle(column.id, value)
                                                            }}
                                                        >
                                                            <Tooltip
                                                                title={value || ''}
                                                                arrow
                                                                placement="top"
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            fontSize: '12px',
                                                                            maxWidth: '500px'
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span style={{ fontSize: '0.7rem' }}>{value || '-'}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '6px 16px',
                                borderTop: '1px solid #e0e0e0',
                                backgroundColor: '#f5f5f5',
                                minHeight: '48px'
                            }}>


                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
                                        Showing {filteredRows.length > 0 ? page * rowsPerPage + 1 : 0} - {Math.min((page + 1) * rowsPerPage, filteredRows.length)} of {filteredRows.length}
                                    </Typography>

                                    <TablePagination
                                        rowsPerPageOptions={[15, 50, 100, 500]}
                                        component="div"
                                        count={filteredRows.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelDisplayedRows={() => null}
                                        sx={{
                                            '& .MuiTablePagination-toolbar': {
                                                minHeight: '30px',
                                                padding: '0 8px'
                                            },
                                            '& .MuiSelect-select': {
                                                fontSize: '0.9rem',
                                                padding: '0px 8px'
                                            },
                                            '& .MuiTablePagination-selectLabel': {
                                                fontSize: '0.9rem'
                                            }
                                        }}
                                    />

                                </Box>
                            </Box>
                        </>
                    ) : (
                        <Typography variant="body1" align="center" sx={{ padding: '40px', fontSize: '0.85rem' }}>
                            No enquiries found
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions sx={{ padding: '8px 16px', borderTop: '1px solid #e0e0e0' }}>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        disabled={selectedRows.size === 0}
                        onClick={() => setShowUpdatePanel(true)}
                        startIcon={<UpdateIcon sx={{ fontSize: '0.9rem' }} />}
                        size="small"
                        sx={{ fontSize: '0.7rem', padding: '4px 12px' }}
                    >
                        Bulk Update ({selectedRows.size})
                    </Button> */}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BulkUpdateEnq;